import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const WhyChooseUsTableRow = ({
    item,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(item.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, item.id)}
                />
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (item?.title?.ar || item?.title?.en || (typeof item?.title === 'string' ? item.title : '-'))
                    : (item?.title?.en || item?.title?.ar || (typeof item?.title === 'string' ? item.title : '-'))
                }
            </TableCell>

            <TableCell align="center">
                {item?.sort_order ?? '-'}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {item?.created_at ? dayjs(item.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, item)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default WhyChooseUsTableRow;
